import { TrackerChip } from '../trackers/TrackerChip.jsx';

/** A habit chip you can actually log from.
 *
 *  The vendored `TrackerChip` takes an `onClick` but renders a `<span>`, which
 *  is neither keyboard-reachable nor announced as an action, and stands 30px
 *  tall against a 44px minimum. The kit is held byte-identical to the handoff,
 *  so the button lives here and the chip stays a chip.
 *
 *  The accessible name carries the state in words, because the chip signals a
 *  met goal with colour and a border — and state is never carried by colour
 *  alone.
 */
export function TrackerToggle({
  name,
  done,
  goal,
  busy = false,
  onToggle,
}: {
  name: string;
  done: number;
  goal: number;
  busy?: boolean;
  onToggle: () => void;
}) {
  const met = done >= goal;
  return (
    <button
      type="button"
      disabled={busy}
      onClick={onToggle}
      aria-label={`${name}, ${done} of ${goal}${met ? ', goal met' : ''}. ${
        met ? 'Undo one' : 'Log one'
      }`}
      style={{
        display: 'flex',
        alignItems: 'center',
        // The 44px floor the rest of the product holds to. The chip itself is
        // shorter, so the button provides the target around it.
        minHeight: 'var(--bujo-tap-min)',
        padding: 0,
        border: 0,
        background: 'transparent',
        cursor: busy ? 'default' : 'pointer',
        opacity: busy ? 0.5 : 1,
        font: 'inherit',
        color: 'inherit',
      }}
    >
      <TrackerChip name={name} done={done} goal={goal} />
    </button>
  );
}
